<template>
  <div class="px-10">
    <!-- <pre>
      customer_tickets {{ customer_tickets }}
    </pre> -->
    <!-- <pre>
   row_selected   {{ row_selected }}
    </pre> -->
    <div class="text-3xl font-bold text-center my-2">
      Customer Dashboard
      <!-- <pre>
        {{ customer_tickets}}
      </pre> -->
      <!-- CUSTOMER DASHBOARD -->
    </div>
    <div class="md:flex w-full md:w-1/3">
      <v-text-field
        label="Search"
        outlined
        color
        dense
        v-model="search"
      ></v-text-field>
    </div>
    <div>
      <div>
        <v-text-field
          readonly
          label="Contract Number"
          :value="$route.query.cn"
        ></v-text-field>
      </div>
      <v-data-table
        dense
        :items-per-page="5"
        class="thead"
        :headers="headers"
        :items="customer_tickets.output"
        :loading="loading"
        :search="search"
      >
        <template v-slot:[`item.reg_date`]="{ item }">
          {{ moment(item.reg_date) }}
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-btn text @click="rowSelected(item)">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.read_status`]="{ item }">
          <div v-if="item.is_read">Read</div>
          <div v-else>Unread</div>
        </template>
      </v-data-table>
    </div>
    <div>
      <v-dialog
        v-model="dialog"
        persistent
        :overlay="false"
        width="650px"
        transition="dialog-transition"
      >
        <div class="bg-white">
          <div class="text-right">
            <v-btn text @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <SelectedRow :row_selected="row_selected" :history="history" />
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import axios from "axios";
import SelectedRow from "../components/SelectedRow.vue";
import SecureStorage from "../../../utils/secureStorage";

export default {
  data() {
    return {
      read: false,
      history: [],
      total_emails: [],
      open_ticket: false,
      loading: false,
      row_selected: [],
      user_id: null,
      dialog2: false,
      search: "",
      dialog: false,
      headers: [
        {
          text: "Date Submitted",
          value: "reg_date",
          class: "thead1",
        },

        {
          text: "Classification",
          value: "classification",
          class: "thead1",
        },
        {
          text: "Subject",
          value: "subject",
          class: "thead1",
        },

        {
          text: "Ticket Number",
          value: "moldex_ticket_number",
          class: "thead1",
        },
        {
          text: "Progress",
          value: "remarks",
          class: "thead1",
        },
        {
          text: "Status",
          value: "name",
          class: "thead1",
        },
        {
          text: "Action",
          value: "action",
          class: "thead1",
        },
        {
          text: "Status",
          value: "read_status",
          class: "thead1",
        },
      ],
      customer_tickets: [],
    };
  },
  components: {
    SelectedRow,
  },
  mounted() {
    this.populate_items();
  },
  methods: {
    open() {
      this.open_ticket = true;
    },
    moment(date) {
      return moment(date).format("lll");
    },
    populate_items() {
      let data = {
        user_id: SecureStorage.getItem("auth").userId,
        contract_number: this.$route.query.cn,
        customer_code: SecureStorage.getItem("auth").customerCode,
      };
      axios.post("/tickets/customer_tickets", data).then((res) => {
        this.customer_tickets = res.data;
      });
    },
    rowSelected(selected) {
      this.row_selected = selected;
      this.dialog = true;
      this.getHistory(selected.ticket_id);
      this.checkIfRead(selected.ticket_id);
    },
    checkIfRead(e) {
      let data = {
        ticket_id: e,
      };
      axios.post("/tickets/is_read", data).then((res) => {
        console.log("status read:");
      });
    },
    getHistory(ticket_id) {
      let data = {
        ticket_id: ticket_id,
      };
      try {
        axios.post("/tickets/my-ticket", data).then((res) => {
          this.history = res.data.output;
          this.total_emails = res.data.total_emails;
        });
      } catch (err) {
        console.log(err);
      }
    },
    close() {
      this.dialog = false;
      this.populate_items();
    },
  },
};
</script>

<style>
.thead1 {
  vertical-align: top;
}
</style>
